import React from 'react';

export default function Footer() {
  const footerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: '#000',
    color: '#fff',
    padding: '40px 60px',
    flexWrap: 'wrap',
    gap: '40px',
  };

  const leftSection = {
    flex: '1 1 300px',
  };

  const logoStyle = {
    height: '50px',
    marginBottom: '16px',
  };

  const descriptionStyle = {
    fontSize: '1rem',
    lineHeight: '1.5rem',
    maxWidth: '300px',
  };

  const socialIconsContainer = {
    marginTop: '20px',
    display: 'flex',
    gap: '20px',
  };

  const iconStyle = {
    width: '28px',
    height: '28px',
    fill: '#fff',
    cursor: 'pointer',
  };

  const middleSection = {
    flex: '1 1 300px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '16px',
    fontSize: '1.1rem',
  };

  const menuItems = ['Home', 'Solutions', 'About', 'Contact', 'Resources'];

  const rightSection = {
    flex: '1 1 200px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '16px',
    fontSize: '1.1rem',
    textAlign: 'right',
  };

  return (
    <footer style={footerStyle}>
      <div style={leftSection}>
        <img src="/images/logo.png" alt="Logo" style={logoStyle} />
        <p style={descriptionStyle}>
          Sustainium is dedicated to delivering top-notch data and
          lead generation services for your business growth.
        </p>
        <div style={socialIconsContainer}>
          {/* Example social icons as SVG */}
          <a href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook">
            <svg style={iconStyle} viewBox="0 0 24 24">
              <path d="M22 12a10 10 0 1 0-11.5 9.9v-6.99h-2.7v-2.9h2.7V9.8c0-2.66 1.57-4.13 3.98-4.13 1.15 0 2.36.2 2.36.2v2.6h-1.33c-1.31 0-1.72.82-1.72 1.66v2h2.94l-.47 2.9h-2.47v6.99A10 10 0 0 0 22 12"/>
            </svg>
          </a>
          <a href="https://twitter.com" target="_blank" rel="noreferrer" aria-label="Twitter">
            <svg style={iconStyle} viewBox="0 0 24 24">
              <path d="M23 3a10.9 10.9 0 0 1-3.14.86 5.48 5.48 0 0 0 2.4-3.02 10.93 10.93 0 0 1-3.46 1.32 5.47 5.47 0 0 0-9.32 5A15.54 15.54 0 0 1 2 3s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 6 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"/>
            </svg>
          </a>
          <a href="https://linkedin.com" target="_blank" rel="noreferrer" aria-label="LinkedIn">
            <svg style={iconStyle} viewBox="0 0 24 24">
              <path d="M20 20h-3.6v-5.6c0-1.34-.48-2.26-1.68-2.26-1.1 0-1.76.75-2.06 1.48-.1.26-.13.62-.13.98v5.4h-3.6s.05-8.76 0-9.67h3.6v1.37c.48-.74 1.34-1.8 3.28-1.8 2.4 0 4.2 1.57 4.2 4.96v5.14zM6.4 8.94c-1.22 0-2.02.8-2.02 1.85 0 1.04.78 1.84 1.96 1.84h.02c1.24 0 2-0.8 2-1.84-.02-1.05-.76-1.85-1.96-1.85zm-1.78 11.06h3.56v-9.67H4.62v9.67zM22 3H2v18h20V3z"/>
            </svg>
          </a>
        </div>
      </div>

      <nav style={middleSection}>
        {menuItems.map((item, idx) => (
          <a
            href={`/${item.toLowerCase()}`}
            key={idx}
            style={{ color: '#fff', textDecoration: 'none', cursor: 'pointer' }}
          >
            {item}
          </a>
        ))}
      </nav>

      <nav style={rightSection}>
        <a href="/privacy-policy" style={{ color: '#fff', textDecoration: 'none' }}>
          Privacy Policy
        </a>
        <a href="/terms-and-conditions" style={{ color: '#fff', textDecoration: 'none' }}>
          Terms and Conditions
        </a>
        <a href="/about" style={{ color: '#fff', textDecoration: 'none' }}>
          About Us
        </a>
      </nav>
    </footer>
  );
}
